import Echo from 'laravel-echo';
import io from 'socket.io-client';
import { SOCKET_URL } from './constants';

const getEchoAuth = (token) => ({
    headers: token ? {Authorization: `Bearer ${token}`} : {},
});

window.Echo = new Echo({
    broadcaster: 'socket.io',
    host: SOCKET_URL,
    client: io,
    transports: ['websocket'],
    forceTLS: false,
    disableStats: true,
    auth: getEchoAuth(localStorage.getItem('authToken')),
});

export const setEchoAuthToken = (token) => {
    if (!window.Echo?.connector?.options) return;

    window.Echo.connector.options.auth = getEchoAuth(token);
};

window.Echo.connector.socket.on('connect', () => {
    console.log('Echo connected to socket.io v2!');
});

window.Echo.connector.socket.on('connect_error', (err) => {
    console.error('Connection Error:', err.message);
});

export default window.Echo;
